import React, { Component } from "react";
import { withRouter } from "react-router";
import "../Order/order.scss";
import $ from "jquery";
import "floating-scroll/dist/jquery.floatingscroll.min.js";
import "floating-scroll/dist/jquery.floatingscroll.css";

class OrderList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            shipped: [],
            loaded: false,
            preY: 0,
            placeholder: "Loading",
            loading: false,
            option: 1
        };
        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(refesh, option) {
        this.setState({ loading: true });
        let since_id = refesh ? 0 : (this.state.data.length == 0 ? 0 : this.state.data[this.state.data.length - 1].id);
        let url = "";
        switch (option) {
            case 1: 
                url = "/api/OrderList/" + since_id;
                break;
            case 2:
                url = "/api/OrderListStatus/fulfillment_status/unfulfilled/" + since_id;
                break;
            case 3:
                url = "/api/OrderListStatus/financial_status/unpaid/" + since_id;
                break;
        }
        console.log(url);
        fetch(url)
            .then((response) => {
                if (response.status > 400) {
                    return this.setState(() => {
                        return { placeholder: "Something went wrong!" };
                    });
                }
                return response.json();
            })
            .then((data) => {
                let shipped = [];
                data.orders.forEach((o) => {
                    let ns = 0;
                    o.fulfillments.forEach((s) => {
                        s.line_items.forEach((i) => {
                            ns += i.quantity;
                        });
                    });
                    shipped.push(ns);
                });
                if (refesh) {
                    this.setState(() => {
                        return {
                            data: data.orders,
                            shipped,
                            loaded: true,
                            loading: false,
                            option,
                            preY: 0
                        };
                    });
                } else {
                    this.setState(() => {
                        return {
                            data: [...this.state.data, ...data.orders],
                            shipped: [...this.state.shipped, ...shipped],
                            loaded: true,
                            loading: false,
                            option
                        };
                    });
                }
            });
    }
    handleObserver(entities, observer) {
        const y = entities[0].boundingClientRect.y;
        if (this.state.prevY > y) {
            this.fetchData(false, this.state.option);
            this.$el.floatingScroll("update");
        }
        this.setState({ prevY: y });
    }
    componentDidMount() {
        this.fetchData(true,1);

        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };

        this.observer = new IntersectionObserver(this.handleObserver.bind(this), options);
        this.observer.observe(this.loadingRef);
        this.$el = $(this.el);
        this.$el.floatingScroll("init");
    }
    componentWillUnmount() {
        this.$el.floatingScroll("destroy");
    }
    render() {
        const loadingCSS = {
            height: "100px",
            margin: "30px",
        };
        const loadingTextCSS = { display: this.state.loading ? "block" : "none" };
        return (
            <div>
                <div className="custom-main-title">Orders</div>
                <div className="card">
                    <div className="card-body custom-main-body">
                        <ul className="nav custom-nav">
                            <li className={["nav-item", (this.state.option==1?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 1)}>
                                    All
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==2?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 2)}>
                                    Unfulfilled
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==3?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 3)}>
                                    Unpaid
                                </a>
                            </li>
                        </ul>
                        <input className="form-control form-control-dark w-100 custom-order-search" type="text" placeholder="Search" aria-label="Search" />
                        <div className="custom-table-wrapper" ref={el => this.el = el}>
                            <table className="table table-striped table-hover custom-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="cTop" />
                                            </div>
                                        </th>
                                        <th>Order Number</th>
                                        <th>Status</th>
                                        <th>Customer</th>
                                        <th>Company</th>
                                        <th>Shipping Via</th>
                                        <th>Order Date</th>
                                        <th>Payment</th>
                                        <th>CVV</th>
                                        <th>AVS</th>
                                        <th>Order Items</th>
                                        <th>Order Quantity</th>
                                        <th>Shipped Quantity</th>
                                        <th>Order Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.map((item, idx) => {
                                        return (
                                            <tr
                                                onClick={() => {
                                                    window.open("https://dev-fame-plus.myshopify.com/admin/orders/"+item.id+"?orderListBeta=true");
                                                }}
                                            >
                                                <td>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id={"c" + item.id} />
                                                    </div>
                                                </td>
                                                <td>{item.order_number}</td>
                                                <td>{item.confirmed ? "Confirm" : "Unconfirm"}</td>
                                                <td>
                                                    {item.customer != undefined ? item.customer.first_name : ""} {item.customer != undefined ? item.customer.last_name : ""}
                                                </td>
                                                <td>
                                                    {item.customer != undefined
                                                        ? item.customer.default_address != undefined
                                                            ? item.customer.default_address.company == null
                                                                ? ""
                                                                : item.customer.default_address.company
                                                            : ""
                                                        : ""}
                                                </td>
                                                <td>{item.shipping_lines.length > 0 ? item.shipping_lines[0].source : ""}</td>
                                                <td>{item.created_at}</td>
                                                <td>
                                                    {item.payment_details != undefined
                                                        ? item.payment_details.credit_card_company
                                                        : item.payment_gateway_names.length > 0
                                                        ? item.payment_gateway_names[0]
                                                        : ""}
                                                </td>
                                                <td>{item.payment_details != undefined ? (item.payment_details.cvv_result_code == null ? "" : "true") : ""}</td>
                                                <td>{item.payment_details != undefined ? (item.payment_details.avs_result_code == null ? "" : "true") : ""}</td>
                                                <td>{item.line_items.length}</td>
                                                <td>{item.line_items.map((it) => it.quantity).reduce((a, b) => a + b, 0)}</td>
                                                <td>{this.state.shipped[idx]}</td>
                                                <td>{item.total_price}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div ref={(loadingRef) => (this.loadingRef = loadingRef)} style={loadingCSS}>
                            <span style={loadingTextCSS}>Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(OrderList);

